import { create } from 'zustand';
import { Appointment } from '../types';

interface AppointmentStore {
  appointments: Appointment[];
  editingAppointment: Appointment | null;
  
  // Actions
  setAppointments: (appointments: Appointment[]) => void;
  addAppointment: (appointment: Appointment) => void;
  updateAppointment: (appointment: Appointment) => void;
  deleteAppointment: (appointmentId: string) => void;
  setEditingAppointment: (appointment: Appointment | null) => void;
  
  // Computed
  getTodaysAppointments: () => Appointment[];
  getUpcomingAppointments: () => Appointment[];
  getCompletedAppointments: () => Appointment[];
  getAppointmentsByPatient: (patientId: string) => Appointment[];
}

export const useAppointmentStore = create<AppointmentStore>((set, get) => ({
  appointments: [],
  editingAppointment: null,
  
  setAppointments: (appointments) => set({ appointments }),
  
  addAppointment: (appointment) => set((state) => ({
    appointments: [...state.appointments, appointment]
  })),
  
  updateAppointment: (appointment) => set((state) => ({
    appointments: state.appointments.map(a => a.id === appointment.id ? appointment : a)
  })),
  
  deleteAppointment: (appointmentId) => set((state) => ({
    appointments: state.appointments.filter(a => a.id !== appointmentId)
  })),
  
  setEditingAppointment: (appointment) => set({ editingAppointment: appointment }),
  
  getTodaysAppointments: () => {
    const { appointments } = get();
    const today = new Date().toISOString().split('T')[0];
    return appointments.filter(apt => apt.date === today);
  },
  
  getUpcomingAppointments: () => {
    const { appointments } = get();
    return appointments.filter(apt => apt.status === 'scheduled');
  },
  
  getCompletedAppointments: () => {
    const { appointments } = get();
    return appointments.filter(apt => apt.status === 'completed');
  },
  
  getAppointmentsByPatient: (patientId) => {
    const { appointments } = get();
    return appointments.filter(apt => apt.patientId === patientId);
  }
}));